import { ERROR_TYPE_PARSE } from './client-constants'
import logger from './logger'

export interface ParsedError {
  msg: string
  statusCode: number
  errorType?: string
}

/**
 * Parses error string to extract msg and statusCode for FPTI tracking (LI-136131)
 */
export const hasJsonError = (error: string): ParsedError => {
  try {
    const { msg, statusCode, errorType } = JSON.parse(
      error.replace('Error:', '')
    )
    return {
      msg: msg || 'Unknown error',
      statusCode: statusCode ?? 0,
      errorType
    }
  } catch (err) {
    logger.error('hasJsonError_parse_failed', { error, parseError: err })
    const msg = error.replace(/^(Error|TypeError|SyntaxError):\s*/i, '').trim()
    return {
      msg: msg || 'Unknown error',
      statusCode: 0,
      errorType: ERROR_TYPE_PARSE
    }
  }
}
